import React, { useState } from 'react';
import { TableRow, TableCell } from 'carbon-components-react';
import { SubtractAlt16 } from '@carbon/icons-react';
import { selectAlertsData } from 'redux/alerts';
import { useDispatch, useSelector } from 'react-redux';
import { deleteApiKeysStart } from 'redux/user/actions';
import { addAlert, removeAlert } from 'redux/alerts/actions';
import { v4 as UUIDV4 } from 'uuid';

const DeleteIcon = ({ selected }: { selected: boolean }) => {
  return (
    <div className="display-row-delete-icon">
      {selected && <SubtractAlt16 />}
    </div>
  );
};
const unique_id = UUIDV4();

const DisplayApiKeysRow: React.FC<any> = ({ row, getRowProps }: any) => {
  const alertList = useSelector(selectAlertsData);
  const [selected, setSelected] = useState(false);
  const handleOnMouseEnter = () => setSelected(true);
  const handleOnMouseLeave = () => setSelected(false);
  const dispatch: any = useDispatch();
  const startDeletion = () => {
    dispatch(deleteApiKeysStart(row.id));
    dispatch(removeAlert(unique_id));
  };

  const existingAlert = !!alertList.find(
    (alert: any) => alert.notificationProps.title === 'Delete API key'
  );

  const notificationProps = {
    title: 'Delete API key',
    subtitle: `with ID ${row.cells[0].value}? This action can't be undone.`,
    lowContrast: true,
    doActions: startDeletion,
    actionButtonText: 'Yes, delete'
  };

  const handleOnDeleteClick = () => {
    if (!existingAlert) {
      dispatch(
        addAlert('DELETE_USER_APIKEY_GROUP', 'error', '', '', {
          id: unique_id,
          withClose: false,
          type: 'inline',
          notificationProps
        })
      );
    }
  };

  return (
    <TableRow
      {...getRowProps({ row })}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
    >
      {row.cells.map((cell: any) => (
        <TableCell key={cell.id}>{cell.value}</TableCell>
      ))}

      <TableCell
        className="bx--table-column-menu"
        onClick={handleOnDeleteClick}
      >
        <DeleteIcon selected={selected && !existingAlert} />
      </TableCell>
    </TableRow>
  );
};
DisplayApiKeysRow.displayName = 'DisplayApiKeysRow';
export default DisplayApiKeysRow;
